/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Orders/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Orders({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Orders",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 18,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Orders.Svg"
  data-view-path={viewPath}
 viewBox="0 0 18 18"
 style={{'--as-1-Zniehd': alignSelf,'--mt-2-Zniehd': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Zniehd': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Zniehd': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Zniehd': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Zniehd': opacity,'--w-10-Zniehd': typeof width === 'number' ? `${width}px` : width,'--h-11-Zniehd': typeof height === 'number' ? `${height}px` : height,'--f-12-Zniehd': fill,'--a-7-Zniehd': isAnimated ? animation : "none",'--sd-8-Zniehd': isAnimated ? strokeDashoffset : 0,'--sd-9-Zniehd': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2Orders.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_2293_1680)"
 className="views-block"
>
<path
  data-testid="Tysiav2Orders.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M8.375 2H5.489a2.189 2.189 0 00-1.874 1.195L2 6.308v.016h6.375V2zM2 14.923V7.574h14v7.35A1.077 1.077 0 0114.923 16H3.077A1.077 1.077 0 012 14.923zm14-8.615v.016H9.625V2h2.886a2.19 2.19 0 011.928 1.195L16 6.308zm-5.5 6.067a.625.625 0 100 1.25H13a.625.625 0 100-1.25h-2.5z"
 style={{'--f-12-Zniehd': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}